import React from 'react';
import { theme } from 'styles/theme';
import { LISTING_TYPE } from '../ScreenRequest';
import { css } from '@emotion/react';
import { IconEmpty56 } from 'icons/icon-empty-56';

export const EmptyList = ({ type }: { type: LISTING_TYPE }) => {
	const listingType = type ? type : LISTING_TYPE.SUBMITTED;

	const title = 'Žádné ' + listingTypeTrans[listingType] + ' poptávky';

	return (
		<>
			<div
				css={css`
					// color: ${theme.color.text[300]};
					color: #c5c7d3;
					padding-bottom: 16px;
				`}
			>
				<IconEmpty56 />
			</div>

			<div
				css={css`
					font-weight: 600;
				`}
			>
				{title}
			</div>
			<div
				css={css`
					color: ${theme.color.text['300']};
				`}
			>
				{emptyListingMessage[listingType]}
			</div>
		</>
	);
};

const listingTypeTrans = {
	SUBMITTED: 'potvrzené',
	COMPLETED: 'potvrzené kompletní',
	INCOMPLETED: 'potvrzené nekompletní',
	UNSUBMITTED: 'nepotvrzené',
	EXPORTED: 'exportované',
	NOTEXPORTED: 'neexportované',
	PAST: 'proběhlé',
};

export const emptyListingMessage = {
	SUBMITTED: 'Potvrzené poptávky na eventy, které se teprve budou konat.',
	COMPLETED: 'Potvrzené kompletní poptávky na eventy, které se teprve budou konat.',
	INCOMPLETED: 'Potvrzené nekompletní poptávky na eventy, které se teprve budou konat.',
	UNSUBMITTED: 'Zobrazují se všechny nepotvrzené poptávky.',
	PAST: 'Poptávky na eventy, které již proběhly.',

	EXPORTED: 'Exportované poptávky na eventy, které se teprve budou konat.',
	NOTEXPORTED: 'Neexportované poptávky na eventy, které se teprve budou konat.',
};
